import Transfer from './transfer.vue';
export default Transfer;


//////////////////
// WEBPACK FOOTER
// ./src/admin/components/commonComponents/transfer/index.js
// module id = fxBg
// module chunks = 15